type RemotePattern = {
  hostname?: string;
};

import remotePatterns from '../../imagesRemotePattern';

function escapeRegex(str: string) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function hostnameGlobToRegex(glob: string): RegExp {
  const pattern = '^' + escapeRegex(glob).replace(/\\\*/g, '.*') + '$';
  return new RegExp(pattern, 'i');
}

export function isAllowedUrl(src?: string | null): boolean {
  if (!src) return false;

  let parsed: URL;
  try {
    parsed = new URL(src);
  } catch {
    return false;
  }

  const patterns: RemotePattern[] = remotePatterns as RemotePattern[];

  if (!patterns || patterns.length === 0) {
    return false;
  }

  const host = parsed.hostname;
  return patterns.some((p) => {
    if (!p.hostname) return false;
    const re = hostnameGlobToRegex(p.hostname);
    return re.test(host);
  });
}

export default isAllowedUrl;
